import script from "./ModeloCompleto.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModeloCompleto.vue?vue&type=script&lang=ts&setup=true"

import "./ModeloCompleto.vue?vue&type=style&index=0&id=69c0bb24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c0bb24"]])

export default __exports__